import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { ButtonIconSelectControl, ButtonSelect } from '../../../Select'

import { QA_NAME_ENTITY_TAB_POSTS_ORDERING } from './EntityTabPostsToolbar.constants'
import { getTranslatedOrderingOptions } from './EntityTabPostsToolbar.utils'

import * as styles from './EntityTabPostsToolbar.module.css'

import RefreshIcon from '../../../../icons/refresh.svg'

function EntityTabPostsToolbar({ selectedOrderingValue, onSelectOrdering }) {
  const { t } = useTranslation()

  const translatedOptions = getTranslatedOrderingOptions(t)

  const selectedOption = translatedOptions.find(
    option => option.value === selectedOrderingValue
  )

  return (
    <div className={styles.toolbar}>
      <ButtonSelect
        Control={ButtonIconSelectControl}
        className={styles.orderingSelect}
        controlProps={{
          buttonProps: {
            beforeIconProps: { Icon: RefreshIcon },
            className: styles.orderingButton,
            isGrey: true,
          },
        }}
        dropdownFloatingConfig={{
          dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottomEnd,
          maxWidthByRef: false,
        }}
        dropdownProps={{
          className: styles.dropdown,
        }}
        listProps={{
          headerProps: {
            Search: null,
          },
          itemProps: {
            className: styles.orderingOption,
            contentProps: {
              infoProps: {
                contentTextProps: {
                  textProps: {
                    isSecondary: true,
                  },
                },
              },
            },
          },
        }}
        options={translatedOptions}
        qaName={QA_NAME_ENTITY_TAB_POSTS_ORDERING}
        value={selectedOption}
        onSelectItem={onSelectOrdering}
      />
    </div>
  )
}

export default EntityTabPostsToolbar
